/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelIdeal = new Class({
    Extends:QuriobotElement,
    template: function(){
        var base =  '<div class="panel--wrapper panel--ideal holds--data isLoading" family="{{ key }}" id="{{ eid }}">'+
                    '    <div class="panel--main">'+
                    '        <div class="panel--content">'+
                    '            <div class="ideal--header">'+
                    '                <div class="ideal--icon">'+
                    '                </div>'+
                    '                <p>'+
                    '                {% header_text %}'+
                    '                </p>'+
                    '            </div>'+
                    '            <div class="ideal--form">'+
                    '                <div class="ideal--error"></div>'+
                    '                <form>'+
                    '                    <input type="hidden" id="transaction_amount" value="{% transaction_amount %}" />'+
                    '                    <div class="inline--input">'+
                    '                        <div class="goarrow">'+
                    '                            <div class="goarrow--body"></div>'+
                    '                        </div>'+
                    '                        <select name="bank" id="id_bank" value="---">'+
                    '                            <option value="ABNANL2A">ABN AMRO</option>'+
                    '                            <option value="ASNBNL21">ASB Bank</option>'+
                    '                            <option value="BUNQNL2A">Bunq</option>'+
                    '                            <option value="INGBNL2A">ING</option>'+
                    '                            <option value="KNABNL2H">Knab</option>'+
                    '                            <option value="RABONL2U">Rabobank</option>'+
                    '                            <option value="RBRBNL21">RegioBank</option>'+
                    '                            <option value="SNSBNL2A">SNS Bank</option>'+
                    '                            <option value="TRIONL2U">Triodos Bank</option>'+
                    '                            <option value="FVLBNL22">van Lanschot</option>'+
                    '                        </select>'+
                    '                    </div>'+
                    '                </form>'+
                    '            </div>'+
                    '            <div class="ideal--footer">'+
                    '            <button class="go--button">'+
                    '                <p class="go--button__text">{% go_button_text %}</p>'+
                    '                <div class="goarrow">'+
                    '                    <div class="goarrow--body"></div>'+
                    '                </div>'+
                    '            </button>'+
                    '            </div>'+
                    '        </div>'+
                    '        <div class="panel--overlay">'+
                    '            <div class="icon--checkWrapper fromBottom circle">'+
                    '                <div class="check"></div>'+
                    '            </div>'+
                    '            <button type="button" aria-label="' + this.data.i18n.redo.button.title + '" aria-hidden="true" class="icon--redoWrapper">'+
                    '                <div class="redo"></div>'+
                    '            </button>'+
                    '        </div>'+
                    '    </div>'+
                    '</div>';

        return {'base': base};
    },
    attach: function(){
        this.submitButton = this.element.getElements('button')[0];
        this.submitForm = this.element.getElements('form')[0];
        this.formError = this.element.getElements('.ideal--error')[0];
        this.bankData = this.element.getElements('select')[0];
        this.amount = this.element.getElements('#transaction_amount')[0].get('value');

        this.submitForm.addEvents({
            submit:function(e){
                e.preventDefault();
                e.stopPropagation();
                this.validate();
            }.bind(this)
        });

        this.submitButton.addEvents({
            click:function(e){
                e.preventDefault();
                e.stopPropagation();
                this.validate();
            }.bind(this)
        });
    },
    validate: function(results){
        if(!results){
            this.formError.removeClass('show');

            var apiData = {
                'type':this.api.putType,
                'data':{
                    'bankid':this.bankData.get('value'),
                    'amount':this.amount
                }
            };

            this.element.addClass('isWaiting');
            this.apiCallback(apiData, this.validate.bind(this));
            return;
        }
        this.element.removeClass('isWaiting');
        if(results.data.success){
            this.after();
        }else{
            this.error(results.data);
        }
        return;
    },
    error: function(data){
        var message = data.data.error;
        this.formError.set('html',message);
        this.formError.addClass('show');
    },
    success: function(data){
        this.after();
    },
    after: function(){
        var answerData = {
            answer:{
                'render':false,
                'value': 'successfull transaction',
                'content': 'successfull transaction'
            }
        };

        this.element.addClass('isAnswered');
        this.answerCallback(this.data, answerData);
    }
});
